import { useMutation, history } from "@umijs/max";
import React, {useState} from 'react';
import { assistantIdSocialMedia, getAssistantData } from "../services/VisualizeData";
import { message } from "antd";

const visualizeData = () => {
  const [socialMediaData, setSocialMediaData] = useState<any>([]);
  const [dataAnalysis, setDataAnalysis] = useState<any>([]);
  const { mutate: getAssistantIdSocialMedia, isLoading: isAssistantIdLoading } = useMutation(assistantIdSocialMedia, {
    onSuccess: (data, variables, context) => {
      if (data && Array.isArray(data.payload) && data.payload.length > 0) {
        setSocialMediaData(data.payload)
      } else {
        setSocialMediaData([]);
        message.success("数据加载失败")
      }
    }
  })

  const { mutate: getAssistantDataMutate, isLoading: isAssistantDataLoading } = useMutation(getAssistantData, {
    onSuccess: (data, variables, context) => {
      if (data && Array.isArray(data.payload) && data.payload.length > 0) {
        setDataAnalysis(data.payload)
      } else {
        setDataAnalysis([]);
      }
    }
  })



  return {
    isAssistantIdLoading,
    socialMediaData,
    getAssistantIdSocialMedia,
    isAssistantDataLoading,
    dataAnalysis,
    getAssistantDataMutate
  }
};

export default visualizeData;
